import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sapore-purple flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <img src="/assets/sapore-logo-transparent.png" alt="Sapore Eats" className="h-16 mx-auto mb-2" />
          <p className="text-sapore-gold uppercase tracking-[0.3em] text-xs">Admin Panel</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl" data-testid="admin-login-form">
          <h1 className="font-serif text-2xl text-sapore-purple mb-6">Sign in</h1>
          {error && <div data-testid="login-error" className="bg-red-50 text-red-700 text-sm rounded-lg p-3 mb-4">{error}</div>}
          <label className="block text-sm font-medium text-sapore-ink mb-1.5">Email</label>
          <input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full rounded-xl border border-sapore-border p-3 text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-sapore-purple/30" />
          <label className="block text-sm font-medium text-sapore-ink mb-1.5">Password</label>
          <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-sapore-border p-3 text-sm mb-6 focus:outline-none focus:ring-2 focus:ring-sapore-purple/30" />
          <button data-testid="login-submit" disabled={loading} className="w-full py-3.5 rounded-full bg-sapore-gold text-sapore-ink font-semibold hover:bg-sapore-goldHover transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
            {loading && <Loader2 size={18} className="animate-spin" />} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
